//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/top_tip'
export default {
    data () {
        return {
            show: false
        }
    },
    onLoad () {
        Service.getTips().then((data) => {
            this.show = data.some(({ id, tip_type}) => {
                if (tip_type === 'decoration_prices') {
                    Service.viewTips(id)
                    return true
                }
            })
        })
    },
    methods: {
        hide () {
            this.show = false
        }
    }
}
